module.exports = __webpack_public_path__ + "img/mf.c7d27392.svg";